import useDialogHooks from "../../../../../../../../Components/Dialog/dialog-hooks";
import { useDrawerHooks } from "../../../../../../../../Components/Drawer/drawer-hooks";
import { IProfleHeaderProps } from "./profileHeader";

const useProfileHeader = (props: IProfleHeaderProps) => {
    const { open, onOpen, onClose } = useDialogHooks();
    const { onOpenReserveDialog } = props;
    const { openDrawer, onCloseDrawer, onOpenDrawer } = useDrawerHooks();
    const onReserveDialog = () => {
        onCloseDrawer();
        onOpenReserveDialog()
    };

    return {
        open,
        openDrawer,
        onOpen,
        onClose,
        onOpenDrawer,
        onCloseDrawer,
        onReserveDialog
    }
};

export default useProfileHeader